module.exports = __webpack_public_path__ + "waveOk.svg?d6bcfe60af2245ff3b4962fb4746ec04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/waveOk.svg
// module id = 743
// module chunks = 2